import {defineCssVars} from '@chakra-ui/styled-system';

export const vars = defineCssVars(`radio-button-group`, [
  `background`,
  `color`,
  `border-color`,
  `icon-color`,
  `gap`,
  `box-shadow`,
]);
